import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { DollarSign, Calendar, CheckCircle, Clock, XCircle } from 'lucide-react';

const AdminDashboard = ({ bookings }) => {
  // Calculate statistics
  const totalBookings = bookings.length;
  const confirmedBookings = bookings.filter(b => b.status === 'confirmed');
  const pendingBookings = bookings.filter(b => b.status === 'pending');
  const cancelledBookings = bookings.filter(b => b.status === 'cancelled');

  const totalRevenue = confirmedBookings.reduce((sum, b) => sum + (b.total || 0), 0);
  const pendingRevenue = pendingBookings.reduce((sum, b) => sum + (b.total || 0), 0);

  // This month's bookings
  const thisMonth = new Date().getMonth();
  const thisYear = new Date().getFullYear();
  const thisMonthBookings = confirmedBookings.filter(b => {
    const bookingDate = new Date(b.created_at);
    return bookingDate.getMonth() === thisMonth && bookingDate.getFullYear() === thisYear;
  });
  const thisMonthRevenue = thisMonthBookings.reduce((sum, b) => sum + (b.total || 0), 0);

  const stats = [
    {
      title: 'Total Revenue',
      value: `₹${totalRevenue.toLocaleString('en-IN')}`,
      subtext: 'Confirmed bookings',
      icon: DollarSign,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      title: 'This Month',
      value: `₹${thisMonthRevenue.toLocaleString('en-IN')}`,
      subtext: `${thisMonthBookings.length} bookings`,
      icon: Calendar,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Confirmed',
      value: confirmedBookings.length,
      subtext: 'Completed bookings',
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      title: 'Pending',
      value: pendingBookings.length,
      subtext: `₹${pendingRevenue.toLocaleString('en-IN')} pending`,
      icon: Clock,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
    },
    {
      title: 'Cancelled',
      value: cancelledBookings.length,
      subtext: 'Cancelled bookings',
      icon: XCircle,
      color: 'text-red-600',
      bgColor: 'bg-red-50',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
      {stats.map((stat, index) => (
        <Card key={index} className="border-2 border-[#3D2817]/20">
          <CardContent className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className={`p-3 rounded-full ${stat.bgColor}`}>
                <stat.icon className={`w-6 h-6 ${stat.color}`} />
              </div>
            </div>
            <h3 className="text-sm font-medium text-gray-600 mb-1">{stat.title}</h3>
            <p className="text-2xl font-bold text-[#3D2817]">{stat.value}</p>
            <p className="text-xs text-gray-500 mt-1">{stat.subtext}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AdminDashboard;
